import React from 'react';
import { Link } from 'react-router-dom';
import { SectionCard } from '../common/SectionCard';
import { SeverityPill } from '../common/StatusPills';
import { anomalies } from '../../data/analytics';
import { formatDate } from '../../utils/format';
import type { ApplicationRecord } from '../../types/domain';
export function AnomalyTable({
  records
}: {
  records: ApplicationRecord[];
}) {
  return <SectionCard title="AI anomaly detection" description="Patterns the model flagged against portfolio history — each is advisory and links back to its record" bodyClassName="p-0" data-id="element-340" data-mp="2for87nxi6j3f">
      <ul className="divide-y divide-border" data-id="element-341" data-mp="2oi46l5ec6cww">
        {anomalies.map(anomaly => {
        const record = records.find(item => item.ref === anomaly.ref);
        return <li key={anomaly.id} className="px-4 py-3" data-id="element-342" data-mp="1w11nu1rwbl48">
              <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-343" data-mp="1vzgtod9hu46w">
                <div className="min-w-0" data-id="element-344" data-mp="1ryww58l0cyk8">
                  <p className="text-[13px] font-medium leading-snug" data-id="element-345" data-mp="1rxviqxgirzzc">{anomaly.subject}</p>
                  <p className="mt-0.5 font-mono text-[11px] text-muted-foreground" data-id="element-346" data-mp="27iew4aq4d73">
                    {record ? <Link to={`/applications/${record.id}`} className="hover:underline" data-id="element-347" data-mp="bzo81hcpp0nv">
                        {anomaly.ref}
                      </Link> : anomaly.ref}{' '}
                    · detected {formatDate(anomaly.detectedOn)}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-2" data-id="element-348" data-mp="3kfq27qazplh6">
                  <SeverityPill severity={anomaly.severity} data-id="element-349" data-mp="3pe1cg2575xzx" />
                  <span className="font-mono text-[11px] text-muted-foreground" data-id="element-350" data-mp="3pgnjm0o6ebhm">
                    {anomaly.confidence}%
                  </span>
                </div>
              </div>
              <p className="mt-1.5 text-[12px] leading-relaxed text-muted-foreground" data-id="element-351" data-mp="14q69kdxsetz6">
                {anomaly.signal}
              </p>
              <p className="mt-1.5 border-l-2 border-uae-gold pl-2.5 text-[12px] leading-relaxed" data-id="element-352" data-mp="35pryhedzl0yy">
                {anomaly.recommendation}
              </p>
            </li>;
      })}
      </ul>
    </SectionCard>;
}